import(/* webpackMode: "eager" */ "/vercel/path0/src/app/connect/profile/page.tsx");
